t = require('app/scripts/views/internal/teacup-with-helpers')('comment_edit_controls')

module.exports = ->
  t.div '.edit-controls.u-clearfix', ->

    t.div '.js-too-long-warning.hide', ->
      t.p ->
        t.format 'your-comment-is-too-long'

    t.div '.js-is-empty-warning.hide', ->
      t.p ->
        t.format 'must-have-at-least-one-character'

    t.input '.primary.confirm.js-save-edit', { type: 'submit', value: t.l('save'), tabindex: '2' }

    t.a '.js-discard-comment-edits.icon-lg.icon-close.dark-hover.cancel', { href: '#' }
